const ANONYMOUS_ID_KEY = "ideaweave_anonymous_id";

export function getOrCreateAnonymousId(): string {
  if (typeof localStorage === "undefined") {
    return "";
  }
  let id = localStorage.getItem(ANONYMOUS_ID_KEY);
  if (!id) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `anon-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
    localStorage.setItem(ANONYMOUS_ID_KEY, id);
  }
  return id;
}
